

import React, { useEffect, useState, useRef } from "react";
import { Button, Card, CardHeader, CardBody, CardTitle, FormGroup, Input, Table, Row, Col } from "reactstrap";
import useToken from "../../helpers/useToken"
import useTimeZone from "../../helpers/useTimeZone"
import PaginationCustom from "../PaginationCustom/PaginationCustom"
import TMHLoader from "../TMHLoader/TMHLoader"
import { parseCustomTime, utils_StringIsNullOrEmpty } from "../../helpers/utils";

export default function DBSegmentTable({ notify, db_type = 1 }) {
    const inputRef = useRef(null);
    const [users, setUsers] = useState()
    const { token } = useToken()
    const { timeZone } = useTimeZone()
    const [isLoading, setIsLoading] = useState(false)

    const [pager, setPager] = useState({
        size: 5,
        offset: 0,
        text: ''
    });

    const [totalUser, setTotalUser] = React.useState(5000);

    useEffect(() => {
        const initData = async () => {
            console.log('DBSegmentTable: update data')
            setIsLoading(true)
            var myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
            }

            var params = new URLSearchParams({
                'page_size': pager.size,
                'offset': pager.offset,
                'search_text': pager.text,
                'db_type': db_type
            })

            fetch(process.env.REACT_APP_BASE_URL + "users/db_segment?" + params, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    async (result) => {
                        var json = result.json
                        if (result.ok) {
                            setUsers(json.data)
                            setTotalUser(json.page_dto.total)
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json.message)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [db_type, pager, setIsLoading, token])

    const exportDBSegmentCsv = () => {
        console.log('exportDBSegmentCsv')
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
        }

        var params = new URLSearchParams({
            'timezone': timeZone,
            'db_type': db_type
        })

        fetch(process.env.REACT_APP_BASE_URL + "users/export_db_segment_csv?" + params, requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.blob()
                    .then((blob) => resolve({
                        status: response.status,
                        ok: response.ok,
                        blob,
                    })))
            }).then(
                async (result) => {
                    var blob = result.blob
                    if (result.ok) {
                        setIsLoading(false)
                        var file = window.URL.createObjectURL(blob, 'csv');
                        // window.location.assign(file);
                        var anchor = document.createElement("a");
                        anchor.download = "db_segment_" + db_type + ".csv";
                        anchor.href = file;
                        anchor.click();
                    }
                    else {
                        console.log(result.json.message)
                        setIsLoading(false)
                    }
                }
            )
    }

    const importDBSegmentCsv = (selectedFile) => {
        const formData = new FormData();
        formData.append('file', selectedFile);

        console.log('importDBSegmentCsv')
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formData
        }

        var params = new URLSearchParams({
            'timezone': timeZone,
            'db_type': db_type
        })

        fetch(process.env.REACT_APP_BASE_URL + "users/import_db_segment_csv?" + params, requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                async (result) => {
                    var json = result.json
                    if (result.ok) {
                        console.log(json)
                        var msg = "Process total: " + (json.created_count + json.updated_count + json.failed_count) + " records"
                        if (json.created_count) {
                            msg += "\nCreated " + json.created_count + " records"
                        }
                        if (json.updated_count) {
                            msg += "\nUpdated " + json.updated_count + " records"
                        }
                        if (json.failed_count) {
                            msg += "\nFailed " + json.failed_count + " records"
                        }

                        setIsLoading(false)
                        alert(msg)
                        window.location.reload()
                    }
                    else {
                        console.log(json.message)
                    }
                }
            ).finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <TMHLoader active={isLoading}>
            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <Row>
                                <Col md="2">
                                    <CardTitle tag="h3">
                                        DB {db_type} - total: {totalUser}
                                    </CardTitle>
                                </Col>

                                <Col md="2">
                                    <CardTitle tag="h3">
                                        Export {" "}
                                        <Button onClick={() => exportDBSegmentCsv()} className="btn-icon btn-simple" color="success" size="sm">
                                            <i className="fa-solid fa-file-export" />
                                        </Button>
                                    </CardTitle>
                                </Col>

                                <Col md="2">

                                </Col>

                                {
                                    db_type !== 1 && <Col>
                                        <CardTitle tag="h4">
                                            Import {" "}
                                            <input ref={inputRef} type="file" onChange={(e) => importDBSegmentCsv(e.target.files[0])} />
                                        </CardTitle>
                                    </Col>
                                }
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md="4" className="pt-2">
                                    <CardTitle tag="h5">Shows {" "}
                                        <select value={pager?.size} onChange={(e) => setPager({
                                            ...pager,
                                            size: e.target.value,
                                            text: pager.text,
                                            offset: 0
                                        })}>
                                            <option>5</option>
                                            <option>10</option>
                                            <option>25</option>
                                            <option>50</option>
                                            <option>100</option>
                                        </select> entries
                                    </CardTitle>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label>Search</label>
                                        <Input
                                            placeholder="Search User Name, User ID, PIN, Device ID, Mobile Id"
                                            type="text"
                                            onChange={(e) => {
                                                let text = e.target.value.replace(/\s/g, '')
                                                if (text.length > 3 || text.length === 0) {
                                                    setPager({
                                                        ...pager,
                                                        size: pager.size,
                                                        offset: 0,
                                                        text: text
                                                    })
                                                }
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Table striped className="tablesorter">
                                <thead className="text-primary">
                                    <tr>
                                        <th>Created</th>
                                        <th>Method</th>
                                        <th>Email</th>
                                        <th>Email IP</th>
                                        <th>Roku Device IFA</th>
                                        <th>Roku IFA IP</th>
                                        <th>Pin</th>
                                        <th>PIN Verified</th>
                                        <th>Mobile ID</th>
                                        {db_type === 1 && <th>Note</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {users?.map((userData) => {
                                        return (
                                            <tr key={userData.user_id}>
                                                <td>{parseCustomTime(userData.signup_date, timeZone)}</td>
                                                <td>{userData.method}</td>
                                                <td>{userData.email}</td>
                                                <td>{userData.email_ip}</td>
                                                <td>{userData.ifa}</td>
                                                <td>{userData.ifa_ip}</td>
                                                <td>{userData.pin}</td>
                                                <td>{userData.device_id ? "YES" : "NO"}</td>
                                                <td>{userData.mobile_id}</td>
                                                {db_type === 1 && <td>{userData.note ? "From db" + userData.note : ""}</td>}
                                            </tr>)
                                    }
                                    )}
                                </tbody>
                            </Table>
                            <PaginationCustom pager={pager} total={totalUser} setPager={setPager} />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </TMHLoader>
    )
}